import React from "react";

export const useStopRecordingAndUploadCm = (
  mediaRecorderRef,
  timerRef,
  setIsRecording,
  setIsUploadingCm,
  chunksRef,
  loan_details,
  dispatch,
  VideoUploadCmAction,
) => {
  const stopRecordingAndUploadCm = React.useCallback(async () => {
    // Check if recording is active
    const isRecording =
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording";

    if (isRecording) {
      clearInterval(timerRef.current);

      mediaRecorderRef.current.stop();
      setIsRecording(false);
      setIsUploadingCm(true);

      return new Promise((resolve) => {
        mediaRecorderRef.current.onstop = async () => {
          const videoBlob = new Blob(chunksRef.current, {
            type: mediaRecorderRef.current.mimeType,
          });
          chunksRef.current = [];

          try {
            const details = loan_details();
            const loanID = details?.loan_id ? String(details?.loan_id) : null;
            const version = details?.version ? Number(details.version) + 1 : 1;
            const applicant =
              details?.user_type?.name ||
              details?.user_type_label ||
              "Applicant";
            const prefix = `${loanID}/CM`;
            const filePrefix = prefix.replace(/\//g, "_");
            const fileName = `${filePrefix}_version_${version}.mp4`;
            //const path = `Test/${loanID}/${applicant}/version_${version}`;
            const path = `production/${loanID}/${applicant}/version_${version}`;
            const videoUrl = `${path}/${fileName}`;

            // Creating FormData for CM video upload - Only 4 fields (no frames)
            const formData = new FormData();

            // 1) cm_video_file
            formData.append("cm_video_file", videoBlob, fileName);

            // 2) loan_id
            formData.append("loan_id", loanID);

            // 3) cm_video_name
            formData.append("cm_video_name", fileName);

            // 4) cm_video_url
            formData.append("cm_video_url", videoUrl);

            // Debug: Log form data contents
            // console.log("=== CM FormData Contents ===");
            // for (let pair of formData.entries()) {
            //   if (pair[1] instanceof Blob) {
            //     console.log(
            //       `${pair[0]}: [Blob] ${pair[1].type} - ${pair[1].size} bytes`,
            //     );
            //   } else {
            //     console.log(`${pair[0]}: ${pair[1]}`);
            //   }
            // }
            // console.log("============================");

            // Send via Redux action
            dispatch(VideoUploadCmAction(formData));
            resolve();
          } catch (error) {
            console.error("Error preparing CM upload:", error);
            setIsUploadingCm(false);
            resolve();
          }
        };
      });
    }
    return Promise.resolve();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return { stopRecordingAndUploadCm };
};
